module.exports = __webpack_public_path__ + "53e7b3a55181f86322e1eea1b2154c1c.svg";